var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"weather-widget"},[(_vm.loading)?_c('div',{staticClass:"weather-widget__loader"},[_c('Loader')],1):(_vm.weather)?_c('LocationHeader',{attrs:{"weather-data":_vm.weather,"is-widget":true},on:{"forward-location":_vm.getNewLocation}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }